var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"SvgTarget",style:({ transform: _vm.sMatrix })},[_c('image',{staticClass:"SvgTarget-image",attrs:{"xlink:href":"/image.png","width":100,"height":100}})])}
var staticRenderFns = []

export { render, staticRenderFns }